module.exports = __webpack_public_path__ + "63dd8a415cbd84983bdf8fcd2806f7a2.pdf";